export const POST_LIKE_PERMISSIONS = {
  like: 'can_like_post',
  unlike: 'can_unlike_post',
}
